import React from "react";
import moment from "moment";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  // Checkbox,
  Button,
  Modal,
  Link,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import BlankImg from "../../assets/images/blank.jpg";

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];

const ViewTournament = ({ setUserView, userView, deleteSelected }) => {
  return (
    <>
      <Modal
        open={userView}
        onClose={() => setUserView(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="deleteModal view_user_Modal"
          sx={{ padding: "0", overflow: "hidden" }}
        >
          <Box sx={{ overflow: "auto", height: "100%", maxHeight: "45vh" }}>
            <Card sx={{}}>
              <CardMedia
                component="img"
                height="140"
                sx={{ objectFit: "contain", padding: "16px 16px 0 16px" }}
                image={
                  deleteSelected.current && deleteSelected.current.img
                    ? deleteSelected.current.img
                    : BlankImg
                }
                alt="green iguana"
              />
              <CardContent>
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 0, width: "100%" }}
                    aria-label="simple table"
                  >
                    <TableBody>
                      {/* {deleteSelected.current &&
                      Object.keys(deleteSelected.current)} */}
                      <TableRow
                        key="Mtitle"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          TITLE
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                            deleteSelected.current.title}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        key="Mdescription"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          DESCRIPTION
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                            deleteSelected.current.description}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        key="Mclub_name"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          CLUB NAME
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                            deleteSelected.current.club}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        key="Mregion"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          REGION
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                            deleteSelected.current.region}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        key="MCategorys"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          CATEGORY
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                            deleteSelected.current.categoryName}
                        </TableCell>
                      </TableRow>
                      {deleteSelected.current &&
                      deleteSelected.current.subCategoryName ? (
                        <TableRow
                          key="MCategorys"
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            className="modal_table_head"
                          >
                            SUB CATEGORY
                          </TableCell>
                          <TableCell align="left">
                            {" "}
                            {deleteSelected.current &&
                              deleteSelected.current.subCategoryName}
                          </TableCell>
                        </TableRow>
                      ) : null}
                      <TableRow
                        key="Mvisibility"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          VISIBILITY
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                          deleteSelected.current.visibility
                            ? "Public"
                            : "Private"}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        key="mfrom"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          FROM
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                          deleteSelected.current.from_uk
                            ? "UK"
                            : "Outside UK"}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        key="Mcreated"
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="modal_table_head"
                        >
                          CREATED AT
                        </TableCell>
                        <TableCell align="left">
                          {" "}
                          {deleteSelected.current &&
                            moment(deleteSelected.current.createdAt).format(
                              "MMM D,YYYY",
                            )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
              <CardActions>
                <Button
                  size="small"
                  // color="primary"
                  sx={{ color: "#EF364E" }}
                  onClick={() => setUserView(false)}
                >
                  Exit
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ViewTournament;
